export const toggleTheme = () => (dispatch) =>
  dispatch({
    type: "TOGGLE_THEME",
  });
